import React from 'react'

function ResultsContainer({ children }) {
  return <div className="columns small-12">{children}</div>
}

export default ResultsContainer
